
import React from "react";
import { FaFilePdf, FaFileAlt, FaBullhorn, FaUsers, FaGraduationCap, FaClipboardList, FaExternalLinkAlt, } from "react-icons/fa";

const LatestUpdates = ({ onClose }) => {
    const publicUrl = process.env.PUBLIC_URL || "";

    const sections = [
        {
            title: "Notifications",
            theme: "societies",
            icon: <FaUsers />,
            links: [
                {
                    label: "DSC-2026 School Education Notification",
                    href: "/DSC2026/notifications/School Education Notification.pdf",
                },
                {
                    label: "DSC-2026 Societies Notification",
                    href: "/DSC2026/notifications/Societies Notification.pdf",
                },
                {
                    label: "DSC-2026 School Education Spl Notifcation",
                    href: "/DSC2026/notifications/School Education Spl Edn.pdf",
                },
            ],
        },
        {
            title: "Government Orders",
            theme: "orders",
            icon: <FaClipboardList />,
            links: [
                {
                    label: "G.O.MS.No.50",
                    href: "/DSC2026/Gos/SOCIETIES DSC 2026SE_44979_MS50_E.pdf",
                },
                {
                    label: "G.O.MS.No.51",
                    href: "/DSC2026/Gos/SPECIAL EDUCATION 2026SE_44980_MS51_E.pdf",
                },
                {
                    label: "G.O.MS.No.52",
                    href: "/DSC2026/Gos/GENERAL DSC 2026SE_44981_MS52_E.pdf",
                },
            ],
        },
        {
            title: "Syllabus",
            theme: "dsc",
            icon: <FaFileAlt />,
            links: [
                {
                    label: "DSC-2026 Suggestive Syllabus",
                    href: "/DSC2026/DSC_2026 Suggestive Syllabus-1.pdf",
                },
                // {
                //     label: "Special Education Syllabus",
                //     href: "/DSC2026/Special Education DSC - 2026.pdf",
                // },
            ],
        },
        // {
        //     title: "Press Note",
        //     theme: "press-note",
        //     icon: <FaFileAlt />,
        //     links: [
        //         {
        //             label: "DSC-2026 Press Note",
        //             href: "/DSC2026/DSC-2026 Press Note English.pdf",
        //         },
        //     ],
        // },

    ];

    return (
        <div className="latest-updates-wrapper">
            <div className="latest-updates-header text-center">

                <h4>Important Notice </h4>

                <div className="latest-header-actions">
                    {onClose && (
                        <button type="button" className="latest-close-btn" onClick={onClose}
                            aria-label="Close latest updates" > &times; </button>
                    )}
                </div>
            </div>


            <div className="latest-updates-content">
                {/* <img
                    src={`${process.env.PUBLIC_URL || ""}/img/new2.gif`}
                    className="latest-new-gif"
                    alt="New updates"
                /> */}
                {/* <p style={{ marginBottom: "10px", marginTop: "15px", }} >
                    <a href={process.env.PUBLIC_URL + "/DSC2026/DSC_2026 Suggestive Syllabus-1.pdf"} target="_blank"
                        rel="noopener noreferrer"
                        className="blink-color d-flex align-items-center gap-2"
                        style={{ cursor: "pointer", textDecoration: "none", fontWeight: "600", }} >
                        <FaFilePdf size={20} />
                        <span>Click here for DSC-2026 Suggestive Syllabus</span>
                        <FaExternalLinkAlt size={13} /> </a>
                </p> */}
                {sections.map((section) => (
                    <div className={`update-section ${section.theme}`} key={section.theme} >
                        <div className="update-section-icon">
                            {section.icon}
                        </div>

                        <div className="update-section-content">
                            <h5>{section.title}</h5>

                            <div className="update-links">
                                {section.links.map((link) => (
                                    <a href={`${publicUrl}${link.href}`} target="_blank"
                                        rel="noopener noreferrer"
                                        className="update-link"
                                        key={link.href}
                                    >
                                        <FaFilePdf className="pdf-icon" />
                                        <span>{link.label}</span></a>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LatestUpdates;